import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FilterIcon from "@mui/icons-material/Tune";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Menu,
  MenuItem,
  Paper,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { CircleLoader } from "react-spinners";
import {
  brandAddRequest,
  brandEditRequest,
  brandResetState,
  brandViewAllRequest,
} from "../../../redux/brands/BrandAction";
import CommonSnackbar from "../../notification/Snackbar";
import { productViewAllRequest } from "../../../redux/products/ProductAction";
import { wholesalerViewAllRequest } from "../../../redux/wholesaler/WholesalerAction";
import { getColumnWidth } from "../../../style/datagridMQ";
import {
  ActiveValue,
  InactiveValue,
  StyledContainer,
} from "../../components/style";
import CustomButton from "../../constant/commonButton";
import CustomDataGrid from "../../constant/commondatagrid";
import ReusableFormFields from "../../constant/reusableFormFields";
import Pagination from "../../constant/CommonPagenation";
import { filterStyles, styles } from "../../components/LoginStyles";
import { alcoholSearchViewAllRequest } from "../../../redux/typeOfAlcohol/TypeOfAlcoholAction";

const BrandList = () => {
  const [rows, setRows] = useState([]);
  const [selection, setSelection] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [openAddDialog, setOpenAddDialog] = useState(false);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("error");
  const [editBrand, setEditBrand] = useState(null);
  const [filterAnchorEl, setFilterAnchorEl] = useState(null);
  const [emptyList, setEmptyList] = useState([]);
  //search
  const [searchQuery, setSearchQuery] = useState("");
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    formState,
    control,
    setValue,
    reset,
    setError,
  } = useForm();
  const { errors } = formState;

  const addBrandState = useSelector((state) => state?.brand?.addBrand);

  const editBrandState = useSelector((state) => state?.brand.editBrand);

  const brandViewAllState = useSelector(
    (state) => state?.brand?.viewAllBrands || {}
  );

  const brandList = brandViewAllState?.data?.data || [];
  const totalRecords = brandViewAllState?.data?.totalRecords || 0;
  const brandPageSize = brandViewAllState?.pageSize || 10;

  // useEffect(() => {
  //   dispatch(brandViewAllRequest(currentPage));
  // }, [currentPage]);

  useEffect(() => {
    dispatch(wholesalerViewAllRequest());
    dispatch(productViewAllRequest());
  }, [dispatch, currentPage]);

  const typeOfAlcoholState = useSelector(
    (state) => state?.TypeAlcohol?.viewAllSearchAlcohols || {}
  );
  const AlcoholList = typeOfAlcoholState?.data?.data || [];

  useEffect(() => {
    if (openAddDialog || openEditDialog) {
      dispatch(alcoholSearchViewAllRequest());
    }
  }, [openAddDialog, openEditDialog, dispatch]);

  const dynamicAlcoholOptions = AlcoholList?.filter(
    (TypeAlcohol) => TypeAlcohol?.status !== 2
  ).map((TypeAlcohol) => ({
    value: TypeAlcohol?.id,
    label: TypeAlcohol?.alcohol_type,
  }));

  const inputFields = [
    {
      name: "type_of_alcohol_id",
      label: "Type Of Alcohol",
      type: "searchable-select",
      size: "selectMedium",
      options: dynamicAlcoholOptions,
      rules: { required: "Type Of Alcohol is required" },
    },
    {
      name: "brand_name",
      label: "Brand Name",
      rules: {
        required: "Brand is required",
      },
    },
    {
      name: "flavour",
      label: "Flavour",
      rules: {
        required: "Flavour is required",
      },
    },
    {
      name: "year",
      label: "Year",
      rules: {
        pattern: {
          value: /^\d{4}$/,
          message: "Enter a valid four-digit year",
        },
      },
    },
  ];

  const inputField = [
    {
      name: "type_of_alcohol_id",
      label: "Type Of Alcohol",
      type: "searchable-select",
      size: "selectMedium",
      defaultValue: AlcoholList[0]?.id,
      options: dynamicAlcoholOptions,
      rules: { required: "Type Of Alcohol is required" },
    },
    {
      name: "brand_name",
      label: "Brand Name",
      rules: {
        required: "Brand is required",
      },
    },
    {
      name: "flavour",
      label: "Flavour",
      rules: {
        required: "Flavour is required",
      },
    },
    {
      name: "year",
      label: "Year",
      rules: {
        pattern: {
          value: /^\d{4}$/,
          message: "Enter a valid four-digit year",
        },
      },
    },
    {
      name: "status",
      label: "Status",
      type: "select",
      options: [
        { value: "1", label: "Active" },
        { value: "2", label: "Inactive" },
      ],
      defaultValue: brandList.status,
      rules: { required: "Status is required" },
    },
  ];

  const columns = (handleDeleteRow) => [
    {
      field: "brand_code",
      headerName: "Brand Code",
      width: getColumnWidth("column"),
      renderCell: (params) => params.value || "N/A",
    },
    {
      field: "type_of_alcohol_id",
      headerName: "Alcohol Name",
      width: getColumnWidth("column"),
      renderCell: (params) => {
        return (
          params.row?.ProductAlcoholType?.alcohol_type || "Unknown Alcohol"
        );
      },
    },
    {
      field: "brand_name",
      headerName: "Brand Name",
      width: getColumnWidth("column"),
      renderCell: (params) => params.value || "Unknown Brand",
    },
    {
      field: "flavour",
      headerName: "Flavour",
      width: getColumnWidth("column"),
      renderCell: (params) => params.value || "No Flavour Specified",
    },
    {
      field: "year",
      headerName: "Year",
      width: getColumnWidth("column"),
      renderCell: (params) => params.value || "N/A",
    },
    {
      field: "status",
      headerName: "Status",
      width: getColumnWidth("column"),
      renderCell: (params) => {
        return params?.value === 1 ? (
          <ActiveValue>Active</ActiveValue>
        ) : (
          <InactiveValue>Inactive</InactiveValue>
        );
      },
    },
    {
      field: "actions",
      headerName: "Actions",
      width: getColumnWidth("actions"),
      renderCell: (params) => (
        <Box display="flex" gap="10px" mt={3}>
          <CustomButton
            variant="contained"
            buttonStyle="SubmitButton"
            color="primary"
            startIcon={<EditIcon />}
            onClick={() => {
              reset();
              setEditBrand(params.row);
              setOpenEditDialog(true);
              setValue("type_of_alcohol_id", params?.row?.type_of_alcohol_id);
              setValue("brand_name", params?.row?.brand_name);
              setValue("flavour", params?.row?.flavour?.toString());
              setValue("year", params?.row?.year?.toString());
              setValue("status", params?.row?.status?.toString());
            }}
          >
            Edit
          </CustomButton>
        </Box>
      ),
    },
  ];

  // useEffect(() => {
  //   if (brandViewAllState?.success) {
  //     setRows(brandList);
  //   } else {
  //     setRows(emptyList);
  //   }
  // }, [brandViewAllState, brandList]);
  const getBrandListPayload = (pageNo, pageSize, searchKey = "") => ({
    pageNo,
    pagesize: pageSize,
    pagination_required: true,
    search_key: searchKey.trim(),
  });

  useEffect(() => {
    dispatch(
      brandViewAllRequest(
        getBrandListPayload(currentPage, brandPageSize, searchQuery)
      )
    );
  }, [currentPage, searchQuery, brandPageSize]);

  useEffect(() => {
    if (brandViewAllState?.success) {
      setRows(brandList);
    } else {
      setRows(emptyList);
    }
  }, [brandViewAllState, brandList]);

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
  };

  const handleDeleteRow = () => {};

  const handleFilterClick = (event) => {
    setFilterAnchorEl(event.currentTarget);
  };

  const handelAddBrand = () => {
    reset({
      type_of_alcohol_id: "",
      brand_name: "",
      flavour: "",
      year: "",
    });
    setOpenAddDialog(true);
  };

  const handleFilterClose = () => {
    setFilterAnchorEl(null);
  };

  const handleFilterCondition = (condition) => {
    const sortedRows = [...rows];
    switch (condition) {
      case "Sort by Brand Asc":
        sortedRows.sort((a, b) => a?.brand_name?.localeCompare(b?.brand_name));
        break;
      case "Sort by Brand Desc":
        sortedRows.sort((a, b) => b?.brand_name?.localeCompare(a?.brand_name));
        break;
      default:
        console.log(`Unknown filter condition: ${condition}`);
        break;
    }
    setRows(sortedRows);
    handleFilterClose();
  };

  useEffect(() => {
    if (addBrandState?.success) {
      setSnackbarMessage("Brand added successfully!");
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
      setOpenAddDialog(false);
      dispatch(brandResetState());
      reset({
        type_of_alcohol_id: "",
        brand_name: "",
        flavour: "",
        year: "",
      });
      dispatch(
        brandViewAllRequest(
          getBrandListPayload(currentPage, brandPageSize, searchQuery)
        )
      );
    } else if (addBrandState?.error) {
      const errorFields = addBrandState?.errormessage || {};
      if (typeof errorFields === "string") {
        setError("brand_name", {
          type: "manual",
          message: errorFields,
        });
      } else if (typeof errorFields === "string") {
        setError("flavour", {
          type: "manual",
          message: errorFields,
        });
      } else if (typeof errorFields === "string") {
        setError("year", {
          type: "manual",
          message: errorFields,
        });
      } else if (
        typeof errorFields === "object" &&
        Object.keys(errorFields).length > 0
      ) {
        Object.keys(errorFields).forEach((field) => {
          setError(field, {
            type: "manual",
            message: errorFields[field],
          });
        });
        setOpenAddDialog(false);
      } else {
        setSnackbarMessage("Failed to add brand. Please try again.");
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
        setOpenAddDialog(false);
      }
    }
  }, [addBrandState]);

  useEffect(() => {
    if (editBrandState?.success) {
      setSnackbarMessage("Brand uploaded successfully!");
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
      setOpenEditDialog(false);
      reset({
        type_of_alcohol_id: "",
        brand_name: "",
        flavour: "",
        year: "",
      });
      dispatch(brandResetState());
      dispatch(
        brandViewAllRequest(
          getBrandListPayload(currentPage, brandPageSize, searchQuery)
        )
      );
    } else if (editBrandState?.error) {
      const errorFields = editBrandState?.errormessage || {};
      if (typeof errorFields === "string") {
        setError("brand_name", {
          type: "manual",
          message: errorFields,
        });
      } else if (typeof errorFields === "string") {
        setError("flavour", {
          type: "manual",
          message: errorFields,
        });
      } else if (
        typeof errorFields === "object" &&
        Object.keys(errorFields).length > 0
      ) {
        Object.keys(errorFields).forEach((field) => {
          setError(field, {
            type: "manual",
            message: errorFields[field],
          });
        });
        setOpenAddDialog(false);
      } else {
        setSnackbarMessage("Failed to add brand. Please try again.");
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
        setOpenAddDialog(false);
      }
    }
  }, [editBrandState]);

  const handleAddCancel = () => {
    reset({
      type_of_alcohol_id: "",
      brand_name: "",
      flavour: "",
      year: "",
    });
    setOpenAddDialog(false);
  };

  const handleEditCancel = () => {
    reset({
      type_of_alcohol_id: "",
      brand_name: "",
      flavour: "",
      year: "",
      status: "",
    });
    setOpenEditDialog(false);
  };

  const handleAddBrand = async (data) => {
    const normalizeText = (text) => text.replace(/\s+/g, " ").trim();
    await dispatch(
      brandAddRequest({ ...data, brand_name: normalizeText(data?.brand_name) })
    );
    await dispatch(
      brandViewAllRequest(
        getBrandListPayload(currentPage, brandPageSize, searchQuery)
      )
    );
  };

  const handleEditBrand = async (data) => {
    const normalizeText = (text) => text.replace(/\s+/g, " ").trim();
    await dispatch(
      brandEditRequest({
        ...data,
        type_of_alcohol_id: data?.type_of_alcohol_id,
        brand_name: normalizeText(data?.brand_name),
        flavour: normalizeText(data?.flavour),
        year: normalizeText(data?.year),
        id: editBrand?.id,
      })
    );
    console.log("data:", data);
    await dispatch(
      brandViewAllRequest(
        getBrandListPayload(currentPage, brandPageSize, searchQuery)
      )
    );
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  return (
    <>
      <Grid container spacing={2} pl={6}>
        <Grid item xs={12} sm={6} md={7} lg={8} xl={9}>
          <Box className="headingTable">
            <h1>Brand Management</h1>
            <p>Here is the complete list of Brands data</p>
          </Box>
        </Grid>
        <Grid item xs={12} sm={6} md={5} lg={4} xl={3}>
          <Box style={filterStyles.style}>
            <Button
              variant="contained"
              onClick={handelAddBrand}
              sx={styles.addButtonColor}
            >
              Add New
            </Button>

            <Button
              variant="contained"
              startIcon={<FilterIcon color="blue" />}
              endIcon={<ExpandMoreIcon />}
              onClick={handleFilterClick}
              sx={filterStyles.filterColor}
            >
              Filter
            </Button>
          </Box>
        </Grid>
      </Grid>

      <StyledContainer>
        <Menu
          anchorEl={filterAnchorEl}
          open={Boolean(filterAnchorEl)}
          onClose={handleFilterClose}
        >
          <MenuItem onClick={() => handleFilterCondition("Sort by Brand Asc")}>
            Brand Name A-Z
          </MenuItem>
          <MenuItem onClick={() => handleFilterCondition("Sort by Brand Desc")}>
            Brand Name Z-A
          </MenuItem>
        </Menu>

        <Paper>
          {/* search */}
          <Box display="flex" justifyContent="flex-end" mb={2}>
            <input
              type="text"
              placeholder="Search by brand/alcohol name or code..."
              value={searchQuery}
              onChange={handleSearchChange}
              style={{
                padding: "8px 12px",
                borderRadius: "4px",
                border: "1px solid #ccc",
                width: "300px",
              }}
            />
          </Box>
          <Box>
            {brandViewAllState?.inProgress && (
              <Box
                position="absolute"
                top={0}
                left={0}
                right={0}
                bottom={0}
                bgcolor="rgba(255, 255, 255, 0.5)"
                zIndex={1000}
              >
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  height="100%"
                >
                  <CircleLoader
                    loading={brandViewAllState?.inProgress}
                    size={50}
                    color="#0458d3"
                  />
                </Box>
              </Box>
            )}
            <CustomDataGrid
              rows={rows}
              columns={columns(handleDeleteRow)}
              pageSize={brandPageSize}
              pagination={true}
              rowHeight={70}
              onSelectionModelChange={(newSelection) => {
                setSelection(newSelection);
              }}
              sx={filterStyles.modalHeight(rows)}
            />
          </Box>
        </Paper>

        <Pagination
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          totalRecords={totalRecords}
          pageSize={brandPageSize}
        />

        {/* Add Brand Dialog */}
        <Dialog
          open={openAddDialog}
          onClose={() => setOpenAddDialog(false)}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle sx={styles.dialogtitleAddOrEdit}>
            Add New Brand
          </DialogTitle>
          <DialogContent sx={{ height: "420px" }}>
            {/* 315px*/}
            <form onSubmit={handleSubmit(handleAddBrand)}>
              <ReusableFormFields
                inputFields={inputFields}
                control={control}
                errors={errors}
                register={register}
                setValue={setValue}
              />
              <DialogActions sx={{ marginBottom: "15px" }}>
                <CustomButton
                  buttonStyle="SubmitButton1"
                  type="submit"
                  disabled={addBrandState?.inProgress}
                  loading={addBrandState?.inProgress}
                  sx={styles.dialogtitleAddOrEditSubmitButton}
                >
                  Submit
                </CustomButton>
                <CustomButton
                  onClick={handleAddCancel}
                  sx={styles.dialogtitleAddOrEditCancelButton}
                >
                  Cancel
                </CustomButton>
              </DialogActions>
            </form>
          </DialogContent>
        </Dialog>

        {/* Edit Brand Dialog */}
        <Dialog
          open={openEditDialog}
          onClose={() => setOpenEditDialog(false)}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle sx={styles.dialogtitleAddOrEdit}>
            Update Brand Details
          </DialogTitle>
          <DialogContent sx={{ height: "500px" }}>
            <form onSubmit={handleSubmit(handleEditBrand)}>
              <ReusableFormFields
                inputFields={inputField}
                control={control}
                errors={errors}
                register={register}
                setValue={setValue}
              />
              <DialogActions sx={{ marginBottom: "15px" }}>
                <CustomButton
                  buttonStyle="SubmitButton"
                  type="submit"
                  disabled={editBrandState?.inProgress}
                  loading={addBrandState?.inProgress}
                  sx={styles.dialogtitleAddOrEditSubmitButton}
                >
                  Submit
                </CustomButton>
                <CustomButton
                  onClick={handleEditCancel}
                  sx={styles.dialogtitleAddOrEditCancelButton}
                >
                  Cancel
                </CustomButton>
              </DialogActions>
            </form>
          </DialogContent>
        </Dialog>

        {/* Snackbar */}
        <CommonSnackbar
          open={snackbarOpen}
          message={snackbarMessage}
          severity={snackbarSeverity}
          onClose={handleSnackbarClose}
        />
      </StyledContainer>
    </>
  );
};

export default BrandList;
